export const SURVEY_PATHS = {
  SAMPLE_SURVEY: '/surveys/sampleSurvey',
  SCORE_CARDS: '/surveys/ScoreCards',
  SCORE_CARD_CREATOR: '/surveys/ScoreCardCreator',
  SURVEY_TEMPLATES: '/surveys/SurveyTemplates',
  SELF_ASSESSMENT_SURVEYS: '/surveys/SelfAssessmentSurveys',
  ESAT: '/surveys/ESAT',
  SURVEY_SCORE: '/surveys/SurveyScore',
  CREATE_SURVEY: '/surveys/CreateSurvey',
  FORM_PAGE: '/surveys/FormPage',
  SURVEY_TAB: '/surveys/SurveyTab'
} as const
